<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<div id="background"></div>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-hicrea-sso-login></app-hicrea-sso-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-hicrea-sso-register></app-hicrea-sso-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-hicrea-sso-forgot-password></app-hicrea-sso-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-hicrea-sso-change-password-sent></app-hicrea-sso-change-password-sent>
  </div>

  <app-hicrea-sso-register-resend
    *ngIf="page === 'register-resend'"
  ></app-hicrea-sso-register-resend>
</ng-container>
